var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-tabs"},_vm._l((_vm.tabs),function(tab){return _c('span',{key:tab.key,class:['ui-tabs-tab', {'ui-tabs-tab--active': tab.key === _vm.localValue}],on:{"click":function($event){return _vm.setActiveTab(tab.key)}}},[(tab.icon)?_c('i',{class:['fas', tab.icon]}):_vm._e(),_vm._v(" "+_vm._s(tab.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }